import { IClient } from "interfaces/Client";
import Modal from "react-modal";
import * as S from "./styles";
import Close from "assets/close-small.svg";
import { useState } from "react";

interface ModalProps {
  modalIsOpen: boolean;
  setIsOpen: (value: boolean) => void;
  client: IClient;
}

export function MoreClientDetailsModal({
  modalIsOpen,
  setIsOpen,
  client,
}: ModalProps) {
  function closeModal() {
    setIsOpen(false);
  }

  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      style={S.CustomStyles}
      contentLabel="MoreClientDetails Modal"
    >
      <S.Container>
        <S.Header>
          <header>
            <h2>Dados do cliente</h2>
            <img src={Close} alt="fechar" onClick={closeModal} />
          </header>
        </S.Header>
        <S.DataContainer>
          <S.Content>
            <span>
              <label>Razão social</label>
              <p>{client?.tradingName}</p>
            </span>
            <span>
              <label>Nome do proprietário</label>
              <p>{client?.managerName}</p>
            </span>
            <span>
              <label>Nome fantasia</label>
              <p>{client?.name}</p>
            </span>
            <span>
              <label>E-mail</label>
              <p>{client?.email}</p>
            </span>
            <span>
              <label>CNPJ</label>
              <p>{client?.cnpj}</p>
            </span>
            <span>
              <label>Produto</label>
              <p>{client?.product?.name}</p>
            </span>
            <span>
              <label>Faturamento mínimo</label>
              <p>{client?.minimumBilling}</p>
            </span>
          </S.Content>
        </S.DataContainer>
      </S.Container>
    </Modal>
  );
}
